<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 虚拟电厂 </el-breadcrumb-item>
          <el-breadcrumb-item>日前调度</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="search-box" style="margin-right: 20px">
            <el-input placeholder="计划名称" v-model="keyword"> </el-input>
          </div>
          <div class="r-list">
            <el-date-picker
              style="width: 280px"
              v-model="dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
          </div>
          <div class="search-box">
            <el-button
              type="primary"
              slot="append"
              icon="el-icon-search"
              @click="initData"
              style="float: right"
            ></el-button>
          </div>
          <div class="btn-box" v-show="false">
            <el-button-group>
              <el-button type="primary" @click="toggleToolsBar"></el-button>
            </el-button-group>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="id" min-width="80">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.id }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column prop="planCode" label="计划编码"></el-table-column>
            <el-table-column
              prop="planName"
              label="计划名称"
              min-width="100"
            ></el-table-column>

            <el-table-column label="响应日期" min-width="90">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.planTime }}</span>
              </template>
            </el-table-column>

            <el-table-column label="负荷聚合商统一社会信用代码" min-width="90">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.creditCode }}</span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-view"
                  @click="selectItem(scope.row.id)"
                  >查看</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="deltem(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../../js/axios.config";

export default {
  data() {
    return {
      loading: false,
      keyword: "",
      dateRange: [],
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      params: {
        planName: "",
        startTime: "",
        endTime: "",
        sort: "",
        page: 0,
        pageSize: 0,
      },
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if (!this.dateRange) {
        this.params.startTime = "";
        this.params.endTime = "";
      } else if (this.dateRange.length != 0) {
        this.params.startTime = this.dateRange[0];
        this.params.endTime = this.dateRange[1];
      }
      const _this = this;
      AxiosAjax({
        url:
          "/v2/getDayaheadPlanData?page=" +
          _this.pageIndex +
          "&&pageSize=" +
          _this.pageSize +
          "&&planName=" +
          _this.keyword +
          "&&startTime=" +
          _this.params.startTime +
          "&&endTime=" +
          _this.params.endTime +
          "&&sort=" +
          _this.params.sort,
        success: function (res) {
          _this.totalCount = res.data.data.totalPage;
          _this.listData = res.data.data.resources;
        },
      });
    },

    selectItem(id) {
      this.$router.push({ name: "DayaheadPlanShow", query: { id: id } });
    },
    deltem(id) {
      const _this = this;
      AxiosAjax({
        url: "/v2/deleteDayaheadPlan/" + id,
        method: "delete",
        success: function (res) {
          if (res.data.code == 200) {
            _this.$message({
              message: "删除成功",
              type: "success",
            });
            _this.initData();
          }
        },
      });
    },
    toggleToolsBar() {},
    //每页显示数量
    handleSizeChange(val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
    },
    //跳转到第几页
    handleCurrentChange(val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
    },
  },
  created() {},
};
</script>
<style scoped>
.content-box .table-list .nowrap {
  white-space: inherit;
}
.sb_select > .el-input {
  width: 130px;
}
.zt_select > .el-input {
  width: 130px;
}
</style>




// WEBPACK FOOTER //
// src/components/VirtualPowerPlant/DayaheadPlan/DayaheadPlan.vue